import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('adminToken'));
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem('adminToken'));
  const [loading, setLoading] = useState(false);

  const login = async (username, password) => {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    
    try {
      const response = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const responseText = await response.text();
      let data;
      
      try {
        data = JSON.parse(responseText);
      } catch {
        throw new Error('Invalid server response');
      }
      
      if (!response.ok) {
        throw new Error(data.detail || 'Invalid username or password');
      }

      localStorage.setItem('adminToken', data.access_token);
      setToken(data.access_token);
      setIsAuthenticated(true);
      return data;
    } catch (error) {
      if (error.message.includes('clone') || error.message.includes('Response body')) {
        throw new Error('Invalid username or password');
      }
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setToken(null);
    setIsAuthenticated(false);
  };

  const value = {
    token,
    isAuthenticated,
    loading,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
